import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

const ImageUpload = ({ onImageChange, profileImage }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (profileImage) {
      // If profileImage is a file object, create a preview URL
      const fileURL = URL.createObjectURL(profileImage);
      setPreview(fileURL);
    }
  }, [profileImage]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
      onImageChange?.(file); // Call onImageChange to update parent state
    }
  };

  return (
    <Box
      sx={{
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        margin: '0 auto',
        position: 'relative',
        overflow: 'hidden',
        border: '1px solid rgba(255, 255, 255, 1)',
      }}
    >
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          opacity: 0,
          cursor: 'pointer',
        }}
      />
      {preview ? (
        <img
          src={preview || "/placeholder.svg"}
          alt="Preview"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <AddPhotoAlternateIcon
          sx={{
            fontSize: 40,
            color: '#9e9e9e',
          }}
        />
      )}
    </Box>
  );
};

export default ImageUpload;
